export const REFRESH_URL = "application/v2/refresh-token";

export const TOKEN_REFRESH_ERROR_CODE = "SLC-APPLICATION-901";
